import get from 'lodash/get';
import type { QnAStateType } from '../index';
import type { UserAnswersT } from '../answers';
export const getUserAnswers = (state: QnAStateType) => state.answers || {};
export const getUserAnswersByQuestionId = (state: QnAStateType, questionId: string): UserAnswersT => get(state, `answers.${questionId}.answers`) || [];
export const getUserNoteByQuestionId = (state: QnAStateType, questionId: string) => get(state, `answers.${questionId}.note`) || '';